import { atomWithStore } from "jotai-redux";
import { atomWithObservable } from "jotai/utils";
import store from "../store";
import type { AllActions, StoreUpdates } from "./../reducers/actions";
import { showSavingsIcon$ } from "./showSavingsIcon";

export const CanEscapeRefStore = atomWithObservable<boolean>(() => showSavingsIcon$);

export const RootStore = atomWithStore<StoreUpdates, AllActions>(store);
